module.exports = __webpack_public_path__ + "static/media/20.46e328df.jpg";